import { isToday, startOfDay } from "date-fns";
import { useEffect, useState } from "react";
import { useCountdown } from "../../../common/hooks/useCountdown";
import DisplayDigits from "./DisplayDigits";

const CountdownTimer = ({ countdownTo, setFetchElections, currentTimeOffset }) => {
  const [days, hours, minutes, seconds] = useCountdown(countdownTo, currentTimeOffset);

  // If user stays on elections page and countdown goes to 0, this will trigger re-fetch of elections data
  let serverTime = new Date().getTime() + currentTimeOffset;

  if (serverTime >= countdownTo) {
    // window.location.reload();
    setFetchElections((prev) => prev + 1);
  }

  return (
    <div style={{ width: "250px", float: "right" }}>
      <div className="is-flex is-flex-direction-column">
        <div className="is-flex is-flex-direction-row is-justify-content-space-between">
          {/* Days */}
          <DisplayDigits digits={days} />
          {/* Hours */}
          <DisplayDigits digits={hours} />
          {/* Minutes */}
          <DisplayDigits digits={minutes} />
          {/* Seconds */}
          <DisplayDigits digits={seconds} />
        </div>
      </div>

      <div className={"is-flex is-flex-direction-row is-size-7 is-justify-content-space-between"}>
        <p className="ml-3">dana</p>
        <p className="ml-4">sati</p>
        <p className="ml-3">minuta</p>
        <p className="mr-1">sekundi</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
